import { components } from "./components/index";
import { events } from "./events/index";

const MRC1Section = {
  events,
  components
};

export { MRC1Section };